/* tee-mockup.js
   Instantly swaps the blank shirt photo when the Color variant changes.
   The theme also re-renders the media from the server on variant change, so
   this element only needs to give instant feedback before that completes.
   It reads a colour -> image URL map printed by tee-mockup.liquid. */

(function () {
  if (window.customElements && customElements.get('tee-mockup')) return;

  class TeeMockup extends HTMLElement {
    connectedCallback() {
      this.shirt = this.querySelector('.tee-mockup__shirt');
      this.map = this.readMap();
      this.preload();

      this._onChange = this.onChange.bind(this);
      document.addEventListener('change', this._onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this._onChange);
    }

    readMap() {
      const el = this.querySelector('.tee-mockup__map');
      if (!el) return {};
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return {};
      }
    }

    preload() {
      // warm the cache so swaps feel instant
      Object.values(this.map).forEach(function (url) {
        if (!url) return;
        var img = new Image();
        img.src = url;
      });
    }

    onChange(e) {
      var input = e.target;
      if (!input || input.type !== 'radio' || !input.checked) return;
      if (!/-Color$/i.test(input.name || '')) return;

      var key = (input.value || '').toLowerCase().trim();
      var url = this.map[key];
      if (url && this.shirt) {
        this.shirt.src = url;
        this.shirt.alt = this.shirt.alt.replace(/-.*$/, '- ' + input.value);
      }
    }
  }

  customElements.define('tee-mockup', TeeMockup);
})();

(function () {
  const colors = {
    "White": "#FFFFFF",
    "Heather Gray": "#9C9DA4",
    "Seafoam": "#9FE2BF",
    "Yellow": "#F5D97A",
    "Slate": "#678098",
    "Silver": "#8B8680",
    "Pine": "#4E7F71",
    "Navy": "#3B4559",
    "Mint": "#8CE2D0",
    "Marine": "#5C7F92",
    "Lavender": "#838DC8",
    "Latte": "#BE9971",
    "Graphite": "#646566",
    "Clover": "#6CB791",
    "Chambray": "#A4C7E2",
    "Brick": "#B24D59",
    "Black": "#25282A",
    "Azure": "#7BA4DB",
    "Aqua": "#9ADBE8",
    "Pink": "#FDA5A9",
    "Coral": "#FD6F74"
  };

  function applySwatches() {
    document.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (!input.name || !input.name.endsWith("Color")) return;

      const hex = colors[input.value];
      if (!hex) return;

      const label = document.querySelector(
        'label[for="' + CSS.escape(input.id) + '"]'
      );

      if (!label) return;

      const inner = label.querySelector("div");
      if (!inner) return;

      inner.style.backgroundColor = hex;
      inner.style.opacity = "1";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applySwatches);
  } else {
    applySwatches();
  }

  document.addEventListener("change", function (event) {
    const input = event.target;

    if (
      input &&
      input.name &&
      input.name.endsWith("Color")
    ) {
      setTimeout(applySwatches, 100);
    }
  });

  const observer = new MutationObserver(function () {
    applySwatches();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
